// Build-time marker for first-party code (CAD-6757). The Sentry Vite plugin
// stamps every chunk it builds with this key; at runtime
// `thirdPartyErrorFilterIntegration` checks stack frames against it to tag
// events coming exclusively from unmarked (third-party) scripts. Keep the
// value in sync between vite.config.ts (applicationKey) and
// src/utils/sentry.ts (filterKeys) by importing it from here — a mismatch
// silently tags ALL events as third-party.
export const SENTRY_APPLICATION_KEY = 'cad-ergeon-in';
